import { Modal } from '@/components/widgets/modal';
import { useTranslations } from 'next-intl';
import { DefaultStake } from '../default-stake';
import { bettingSettingModalStyle } from './bet-setting-modal.style';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { SettingItemSwitch } from '../setting-item-switch';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { accountService } from '@/services/account.service';
import { useGetAccountSetting } from '@/hooks/query/use-account-settings-data';
import { useQueryClient } from '@tanstack/react-query';
import { Maybe } from '@nf/utils-common/fpw/monadic';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { KafkaNote } from '@nf/utils-common/constants';
import { useBetslipStore } from '@/store/betslip';

interface BettingPreferenceModalProps {
	isOpen: boolean;
	closeModal: () => void;
}

//setKafka 後補
export const BetSettingModal = ({
	isOpen,
	closeModal
}: BettingPreferenceModalProps) => {
	const t = useTranslations('General');
	const { SiteConfigsData } = useGetSiteConfigs();
	const [betAcceptBetter, setBetAcceptBetter] = useState<boolean>(false);
	const queryClient = useQueryClient();
	const { userSetting } = useGetAccountSetting();
	const view = useAppearanceStore(state => state.view);
	const isParlayMode = useBetslipStore(state => state.isParlayMode);

	useEffect(() => {
		if (isOpen) {
			Maybe(userSetting?.betInfo.betAcceptBetter).fold(() => null, setBetAcceptBetter);
		}
	}, [isOpen, userSetting?.betInfo.betAcceptBetter]);
	

	const toggleAcceptBetterOdds = (settingState: boolean) => {
		const isGalaxy = view === ViewEnum.galaxy;

		const kafkaData = isGalaxy ? {
			note: KafkaNote.GalaxyV2,
			type: 8,
			action: settingState ? 9 : 10
		} : {
			note: KafkaNote.MarsV1,
			type: isParlayMode ? 11 : 10,
			action: isParlayMode
				? settingState ? 1 : 2 // 1: off, 2: on
				: settingState ? 4 : 5 // 4: off, 5: on
		}
		setKafkaNormal(kafkaData);

		setBetAcceptBetter(settingState);
		accountService.setAcceptBetterOdds(queryClient, settingState, userSetting!);
	}
	return (
		<Modal
			isOpen={isOpen}
			closeModal={closeModal}
			title={t('lbl_BetSetting')}
			className={bettingSettingModalStyle.modal}
		>
			<div className={clsx('scrollbar', bettingSettingModalStyle.scrollbar)}>
				<div className={bettingSettingModalStyle.stakeWrapper}>
					<div className={bettingSettingModalStyle.stakeContent}>
						<div className={bettingSettingModalStyle.title}>
							{t('lbl_DefaultStake')}
						</div>   
						<div className={bettingSettingModalStyle.stakeItem}>
							<DefaultStake from="betslip" />
						</div>
					</div>
					
				</div>
				{(SiteConfigsData?.EnableAcceptBetterOdds) ?
					<SettingItemSwitch
						title={t('lbl_AcceptBetterOdds')}
						isSwitchOn={betAcceptBetter}
						callbackFunction={toggleAcceptBetterOdds}
					/> : null}
			</div>
		</Modal>
	)
}

